import { render, staticRenderFns } from "./ClientOrganisations.vue?vue&type=template&id=6834e22c&"
import script from "./ClientOrganisations.vue?vue&type=script&lang=js&"
export * from "./ClientOrganisations.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrganisations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports